import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';

import styles from './VehicleArcMenu.module.css';

function ControlIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="8"
        stroke="currentColor"
        strokeWidth="2"
      />

      <circle
        cx="12"
        cy="12"
        r="2.5"
        stroke="currentColor"
        strokeWidth="2"
      />

      <path
        d="M12 2v3M12 19v3M2 12h3M19 12h3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function HistoryIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M3 12a9 9 0 1 0 3-6.7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />

      <path
        d="M3 4v5h5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M12 7v5l3 2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function EventsIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M6 3h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"
        stroke="currentColor"
        strokeWidth="2"
      />

      <path
        d="M8 8h8M8 12h8M8 16h5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function GeofencesIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />

      <circle
        cx="12"
        cy="9"
        r="2.5"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}

function TrackingIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="8"
        stroke="currentColor"
        strokeWidth="2"
      />

      <circle
        cx="12"
        cy="12"
        r="3"
        stroke="currentColor"
        strokeWidth="2"
      />

      <path
        d="M12 2v3M12 19v3M2 12h3M19 12h3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ReportsIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M5 20V10M12 20V4M19 20v-7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />

      <path
        d="M3 20h18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SentinelIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12 3 20 6v5c0 5-3.4 8.2-8 10-4.6-1.8-8-5-8-10V6l8-3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />

      <path
        d="m9 12 2 2 4-5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const DEFAULT_ITEMS = [
  {
    id: 'control',
    label: 'Control',
    description: 'Centro de control del activo',
    icon: <ControlIcon />
  },
  {
    id: 'history',
    label: 'Histórico',
    description: 'Recorridos y paradas',
    icon: <HistoryIcon />
  },
  {
    id: 'events',
    label: 'Eventos',
    description: 'Alertas y notificaciones',
    icon: <EventsIcon />
  },
  {
    id: 'geofences',
    label: 'Geocercas',
    description: 'Zonas y perímetros',
    icon: <GeofencesIcon />
  },
  {
    id: 'tracking',
    label: 'Rastreo',
    description: 'Seguimiento en tiempo real',
    icon: <TrackingIcon />
  },
  {
    id: 'reports',
    label: 'Informes',
    description: 'Reportes y estadísticas',
    icon: <ReportsIcon />
  },
  {
    id: 'sentinel',
    label: 'Centinela',
    description: 'Protección del vehículo',
    icon: <SentinelIcon />
  }
];

/*
  Disposición vertical.

  Todos los elementos utilizan el mismo eje X.
  El seleccionado solamente crece ligeramente,
  sin formar una curva pronunciada.
*/
const ARC_SLOTS = [
  { offset: -1, translateX: 0, translateY: -72, scale: 1, opacity: 0.97 },
  { offset: 0, translateX: 0, translateY: 0, scale: 1, opacity: 1 },
  { offset: 1, translateX: 0, translateY: 72, scale: 1, opacity: 0.97 }
];

const POINTER_STEP = 36;

function wrapIndex(index, totalItems) {
  if (totalItems <= 0) return 0;

  return (
    (index % totalItems) +
    totalItems
  ) % totalItems;
}

function VehicleArcMenu({
  items = DEFAULT_ITEMS,
  initialIndex = 0,
  visible = true,
  selectedAssetName = '',
  onControlClick,
  onSelect,
  onActiveChange,
  onClose
}) {
  const normalizedItems = useMemo(() => {
    if (!Array.isArray(items)) {
      return [];
    }

    const cleanAssetName =
      typeof selectedAssetName === 'string'
        ? selectedAssetName.trim()
        : '';

    return items
      .filter((item) => item?.id && item?.label)
      .map((item) => {
        if (item.id !== 'control') {
          return item;
        }

        return {
          ...item,
          label: cleanAssetName || 'Control',
          description: cleanAssetName
            ? `Información de ${cleanAssetName}`
            : 'Centro de control del activo'
        };
      });
  }, [items, selectedAssetName]);

  const [activeIndex, setActiveIndex] = useState(() => {
    return wrapIndex(
      initialIndex,
      normalizedItems.length
    );
  });

  // DIVI_RULETA_DETALLES_V3: abierta al entrar; sin persistir el cierre.
  const [collapsed, setCollapsed] = useState(false);
  const toggleRef = useRef(null);
  const pointerStartYRef = useRef(null);
  const pointerLastYRef = useRef(null);
  const pointerAccumulatedRef = useRef(0);
  const pointerMovedRef = useRef(false);

  const wheelLockedRef = useRef(false);

  useEffect(() => {
    setActiveIndex((currentIndex) => {
      return wrapIndex(
        currentIndex,
        normalizedItems.length
      );
    });
  }, [normalizedItems.length]);

  const updateActiveIndex = useCallback(
    (nextIndex) => {
      if (normalizedItems.length === 0) return;

      const circularIndex = wrapIndex(
        nextIndex,
        normalizedItems.length
      );

      setActiveIndex((currentIndex) => {
        if (currentIndex === circularIndex) {
          return currentIndex;
        }

        const nextItem =
          normalizedItems[circularIndex];

        onActiveChange?.(
          nextItem,
          circularIndex
        );

        return circularIndex;
      });
    },
    [normalizedItems, onActiveChange]
  );

  const moveSelection = useCallback(
    (direction) => {
      if (normalizedItems.length === 0) return;

      setActiveIndex((currentIndex) => {
        const nextIndex = wrapIndex(
          currentIndex + direction,
          normalizedItems.length
        );

        const nextItem =
          normalizedItems[nextIndex];

        onActiveChange?.(
          nextItem,
          nextIndex
        );

        return nextIndex;
      });
    },
    [normalizedItems, onActiveChange]
  );

const activePointerIdRef = useRef(null);
  const captureTargetRef = useRef(null);
  const pressedItemRef = useRef(null);
  const activeTouchesRef = useRef(new Set());
  const multiTouchBlockedRef = useRef(false);
  const itemClickRef = useRef(null);

  const releaseArcPointer = useCallback(() => {
    const id = activePointerIdRef.current;
    const target = captureTargetRef.current;

    activePointerIdRef.current = null;
    captureTargetRef.current = null;
    pressedItemRef.current = null;
    pointerStartYRef.current = null;
    pointerLastYRef.current = null;
    pointerAccumulatedRef.current = 0;

    if (id !== null && target?.hasPointerCapture?.(id)) {
      try {
        target.releasePointerCapture(id);
      } catch (_) {}
    }
  }, []);

  const cancelPointerGesture = useCallback(() => {
    pointerMovedRef.current = true;
    releaseArcPointer();
  }, [releaseArcPointer]);

  useEffect(() => {
    const start = event => {
      if (event.pointerType !== 'touch') return;

      activeTouchesRef.current.add(event.pointerId);

      if (activeTouchesRef.current.size > 1) {
        multiTouchBlockedRef.current = true;
        cancelPointerGesture();
      }
    };

    const end = event => {
      activeTouchesRef.current.delete(event.pointerId);

      if (activeTouchesRef.current.size === 0) {
        multiTouchBlockedRef.current = false;
      }

      if (
        event.type === 'pointercancel' &&
        event.pointerId === activePointerIdRef.current
      ) {
        cancelPointerGesture();
      }
    };

    const reset = () => {
      cancelPointerGesture();
      activeTouchesRef.current.clear();
      multiTouchBlockedRef.current = false;
    };

    const visibility = () => {
      if (document.hidden) reset();
    };

    // Observan los dedos sin bloquear los gestos del mapa.
    window.addEventListener('pointerdown', start, true);
    window.addEventListener('pointerup', end, true);
    window.addEventListener('pointercancel', end, true);
    window.addEventListener('blur', reset);
    document.addEventListener('visibilitychange', visibility);

    return () => {
      window.removeEventListener('pointerdown', start, true);
      window.removeEventListener('pointerup', end, true);
      window.removeEventListener('pointercancel', end, true);
      window.removeEventListener('blur', reset);
      document.removeEventListener('visibilitychange', visibility);
      reset();
    };
  }, [cancelPointerGesture]);

  useEffect(() => {
    if (!visible || collapsed) cancelPointerGesture();
  }, [visible, collapsed, cancelPointerGesture]);

  useEffect(() => {
    setCollapsed(false);
  }, [selectedAssetName]);

  const handlePointerDown = useCallback(event => {
    if (
      event.isPrimary === false ||
      multiTouchBlockedRef.current ||
      activeTouchesRef.current.size > 1 ||
      (event.pointerType === 'mouse' && event.button !== 0)
    ) return;

    if (activePointerIdRef.current !== null) return;

        const button = event.target.closest?.('[data-item-index]');
    if (button && !event.currentTarget.contains(button)) return;
    const index = button ? Number(button.dataset.itemIndex) : null;
    if ((index !== null && !Number.isInteger(index)) ||
        !Number.isFinite(event.clientY)) return;

    event.stopPropagation();

    activePointerIdRef.current = event.pointerId;
    captureTargetRef.current = event.currentTarget;
    pressedItemRef.current = index;
    pointerStartYRef.current = event.clientY;
    pointerLastYRef.current = event.clientY;
    pointerAccumulatedRef.current = 0;
    pointerMovedRef.current = false;

    try {
      event.currentTarget.setPointerCapture(event.pointerId);
    } catch (_) {
      cancelPointerGesture();
    }
  }, [cancelPointerGesture]);

  const handlePointerMove = useCallback(event => {
    if (event.pointerId !== activePointerIdRef.current) return;

    const rect =
      captureTargetRef.current?.getBoundingClientRect();

    if (
      !rect ||
      multiTouchBlockedRef.current ||
      !Number.isFinite(event.clientX) ||
      !Number.isFinite(event.clientY) ||
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    ) {
      cancelPointerGesture();
      return;
    }

    event.stopPropagation();

    const movement =
      event.clientY - pointerLastYRef.current;

    pointerLastYRef.current = event.clientY;
    pointerAccumulatedRef.current += movement;

    if (
      Math.abs(event.clientY - pointerStartYRef.current) > 10
    ) {
      pointerMovedRef.current = true;
    }

    const steps = Math.trunc(
      pointerAccumulatedRef.current / POINTER_STEP
    );

    if (steps !== 0) {
      pointerAccumulatedRef.current -= steps * POINTER_STEP;
      moveSelection(-steps);
    }
  }, [moveSelection, cancelPointerGesture]);

  const finishPointerGesture = useCallback(event => {
    if (event.pointerId !== activePointerIdRef.current) return;

    event.stopPropagation();

    const rect =
      captureTargetRef.current?.getBoundingClientRect();
    const index = pressedItemRef.current;

    const tap =
      !pointerMovedRef.current &&
      !multiTouchBlockedRef.current &&
      rect &&
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    releaseArcPointer();

    if (tap && index !== null) { itemClickRef.current?.(normalizedItems[index], index); }
  }, [normalizedItems, releaseArcPointer]);

  const cancelCapturedPointer = useCallback(event => {
    if (event.pointerId === activePointerIdRef.current) {
      cancelPointerGesture();
    }
  }, [cancelPointerGesture]);

  const handleWheel = useCallback(
    (event) => {
      event.preventDefault();

      if (wheelLockedRef.current) return;
      if (Math.abs(event.deltaY) < 3) return;

      wheelLockedRef.current = true;

      moveSelection(
        event.deltaY > 0 ? 1 : -1
      );

      window.setTimeout(() => {
        wheelLockedRef.current = false;
      }, 90);
    },
    [moveSelection]
  );

  const executeItem = useCallback(
    (item, itemIndex) => {
      if (!item) return;

      if (item.id === 'control') {
        onControlClick?.();
        return;
      }

      onSelect?.(
        item,
        itemIndex
      );
    },
    [
      onControlClick,
      onSelect
    ]
  );

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        moveSelection(-1);
        return;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        moveSelection(1);
        return;
      }

      if (
        event.key === 'Enter' ||
        event.key === ' '
      ) {
        event.preventDefault();

        const activeItem =
          normalizedItems[activeIndex];

        if (activeItem) {
          executeItem(
            activeItem,
            activeIndex
          );
        }

        return;
      }

      if (event.key === 'Escape') {
        onClose?.();
      }
    },
    [
      activeIndex,
      executeItem,
      moveSelection,
      normalizedItems,
      onClose
    ]
  );

  const handleItemClick = useCallback(
    (item, itemIndex) => {
      if (pointerMovedRef.current) {
        pointerMovedRef.current = false;
        return;
      }

      if (itemIndex !== activeIndex) {
        updateActiveIndex(itemIndex);
        return;
      }

      executeItem(
        item,
        itemIndex
      );
    },
    [
      activeIndex,
      executeItem,
      updateActiveIndex
    ]
  );
itemClickRef.current = handleItemClick;
  if (
    !visible ||
    normalizedItems.length === 0
  ) {
    return null;
  }

  const visibleItems = ARC_SLOTS.map((slot) => {
    const itemIndex = wrapIndex(
      activeIndex + slot.offset,
      normalizedItems.length
    );

    return {
      ...slot,
      itemIndex,
      item: normalizedItems[itemIndex]
    };
  });

  return (
    <>
    <button
      ref={toggleRef}
      type="button"
      className={styles.collapseToggle}
      aria-label={collapsed ? 'Mostrar funciones del activo' : 'Ocultar funciones del activo'}
      title={collapsed ? 'Mostrar funciones' : 'Ocultar funciones'}
      aria-expanded={!collapsed}
      aria-controls="divi-vehicle-arc"
      onPointerDown={event => event.stopPropagation()}
      onClick={event => {
        event.stopPropagation();
        if (multiTouchBlockedRef.current || activeTouchesRef.current.size > 1) return;
        cancelPointerGesture();
        setCollapsed(current => !current);
      }}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d={collapsed ? 'M9 5l7 7-7 7' : 'M15 5l-7 7 7 7'} />
      </svg>
    </button>
    <div
      className={[styles.root, collapsed ? styles.collapsed : ''].join(' ')}
      id="divi-vehicle-arc"
      aria-hidden={collapsed}
      role="menu"
      aria-label="Funciones del vehículo"
      tabIndex={collapsed ? -1 : 0}
      onKeyDown={handleKeyDown}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={finishPointerGesture}
    onPointerCancel={cancelCapturedPointer}
onLostPointerCapture={cancelCapturedPointer}
      onWheel={handleWheel}
    >
      {normalizedItems.length > 3 && <>
        <svg className={[styles.endArrow, styles.endArrowTop].join(' ')}
          viewBox="0 0 44 54" fill="none" aria-hidden="true">
          <path d="M43.12690 49A230.86847 230.86847 0 0 0 0 0M3.48 8.24L0 0L8.68 2.16" />
        </svg>
        <svg className={[styles.endArrow, styles.endArrowBottom].join(' ')}
          viewBox="0 0 44 54" fill="none" aria-hidden="true">
          <path d="M43.12690 49A230.86847 230.86847 0 0 0 0 0M3.48 8.24L0 0L8.68 2.16" />
        </svg>
      </>}
      {visibleItems.map((slot) => {
        const isActive =
          slot.offset === 0;

        return (
          <button
            key={`${slot.offset}-${slot.item.id}`}
            type="button"
            role="menuitem"
            disabled={collapsed}
            aria-current={
              isActive
                ? 'true'
                : undefined
            }
            aria-label={slot.item.label}
            className={[
              styles.item,
              isActive
                ? styles.activeItem
                : ''
            ]
              .filter(Boolean)
              .join(' ')}
            style={{
              '--arc-x':
                `${slot.translateX}px`,
              '--arc-y':
                `${slot.offset} * var(--arc-step, 72px)`,
              '--arc-scale':
                slot.scale,
              '--arc-opacity':
                slot.opacity
            }}
 data-item-index={slot.itemIndex}
          >
            <span className={styles.icon}>
              {slot.item.icon}
            </span>

            {!isActive && (
              <span className={styles.itemLabel}>
                {slot.item.label}
              </span>
            )}

            {isActive && (
              <>
                <span className={styles.activePanel}>
                  <span
                    className={[
                      styles.activeTitle,
                      slot.item.label.length > 10
                        ? styles.longTitle
                        : ''
                    ]
                      .filter(Boolean)
                      .join(' ')}
                  >
                    {slot.item.label}
                  </span>
                </span>

                <span
                  className={styles.activeArrow}
                  aria-hidden="true"
                />
              </>
            )}
          </button>
        );
      })}
    </div>
    </>
  );
}

export default VehicleArcMenu;